import {
    addDoc,
    doc,
    updateDoc,
    collection,
    deleteDoc,
    getDoc,
} from "firebase/firestore";
import { db } from "../firebase"

export const createClient = async (data: Partial<Client>) => {
    try {
        const res = await addDoc(collection(db, "clients"), data);
        return res;
    } catch (e) {
        return e;
    }
};

export const updateClient = async (data: Partial<Client>) => {
    const clientRef = doc(db, "clients", `${data.id}`);
    try {
        const res = updateDoc(clientRef, data);
        return res;
    } catch (e) {
        return e;
    }
};

export const deleteClient = async (clientId: string) => {
    const clientRef = doc(db, "clients", `${clientId}`);
    try {
        const res = await deleteDoc(clientRef);
        return res;
    } catch (e) {
        return e;
    }
};
